import React from 'react';
import { Search, Bell, SlidersHorizontal, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
import { JobCard, JobProps } from '../components/JobCard';
const TRENDING_JOBS: JobProps[] = [{
  id: '1',
  title: 'Cleaner',
  company: 'CleanCo Services',
  location: 'Estonia, Tallinn',
  salary: '$25 - $100',
  type: 'Hourly',
  tags: ['Cleaning', 'Urgent'],
  isPromoted: true,
  logo: 'https://api.dicebear.com/7.x/avataaars/svg?seed=CleanCo'
}, {
  id: '2',
  title: 'Car Repair',
  company: 'AutoFix Garage',
  location: 'Estonia, Tallinn',
  salary: '$25 - $45',
  type: 'Hourly',
  tags: ['Mechanic', 'Auto'],
  isPromoted: true,
  logo: 'https://api.dicebear.com/7.x/avataaars/svg?seed=AutoFix'
}, {
  id: '3',
  title: 'Dog Walker',
  company: 'PetPals',
  location: 'Tartu, Estonia',
  salary: '$15 - $25',
  type: 'Hourly',
  tags: ['Pets', 'Outdoor'],
  isPromoted: true,
  logo: 'https://api.dicebear.com/7.x/avataaars/svg?seed=PetPals'
}];
const RECOMMENDED_JOBS: JobProps[] = [{
  id: '4',
  title: 'Ux / Ui Designer needed',
  company: 'Private individual',
  location: 'Estonia, Tallinn',
  salary: '$500 - $1200',
  type: 'Project',
  tags: ['Remote', 'Internship', 'Year Exp'],
  logo: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Designer'
}, {
  id: '5',
  title: 'Frontend Developer',
  company: 'TechStar',
  location: 'Remote',
  salary: '$3000 - $5000',
  type: 'Full-time',
  tags: ['React', 'TypeScript', 'Junior'],
  logo: 'https://api.dicebear.com/7.x/avataaars/svg?seed=TechStar'
}];
export function HomePage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.3
  }} className="min-h-screen bg-gray-50 dark:bg-gray-900 pb-24 transition-colors duration-200" data-id="element-49">
      {/* Header */}
      <motion.div initial={{
      y: -20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.4
    }} className="bg-white dark:bg-gray-800 px-6 pt-12 pb-4 sticky top-0 z-30 shadow-sm dark:shadow-gray-900/30" data-id="element-50">
        <div className="flex justify-between items-center mb-6" data-id="element-51">
          <div className="flex items-center gap-3" data-id="element-52">
            <motion.div whileHover={{
            scale: 1.05
          }} className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden border-2 border-white dark:border-gray-600 shadow-sm" data-id="element-53">
              <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Lauri" alt="Profile" className="w-full h-full object-cover" data-id="element-54" />
            </motion.div>
            <div data-id="element-55">
              <p className="text-xs text-gray-500 dark:text-gray-400 font-medium" data-id="element-56">
                My Account
              </p>
              <h2 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-57">
                Welcome, Lauri!
              </h2>
            </div>
          </div>
          <div className="flex gap-3" data-id="element-58">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-10 h-10 rounded-xl border border-gray-200 dark:border-gray-700 flex items-center justify-center text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors relative" data-id="element-59">
              <Bell className="w-5 h-5" data-id="element-60" />
              <motion.span animate={{
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity
            }} className="absolute top-2 right-2.5 w-2 h-2 bg-red-500 rounded-full border border-white dark:border-gray-800" data-id="element-61" />
            </motion.button>
          </div>
        </div>

        {/* Search */}
        <div className="flex gap-3" data-id="element-62">
          <motion.div whileFocus={{
          scale: 1.01
        }} className="flex-1 relative" data-id="element-63">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 dark:text-gray-500" data-id="element-64" />
            <input type="text" placeholder="Search by role, location..." className="w-full pl-12 pr-4 py-3 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:border-[#00D084] focus:ring-1 focus:ring-[#00D084] shadow-sm transition-colors" data-id="element-65" />
          </motion.div>
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-12 h-12 flex-shrink-0 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl flex items-center justify-center text-[#00D084] hover:bg-gray-50 dark:hover:bg-gray-600 shadow-sm transition-colors" data-id="element-66">
            <SlidersHorizontal className="w-5 h-5" data-id="element-67" />
          </motion.button>
        </div>
      </motion.div>

      <div className="p-6 space-y-8" data-id="element-68">
        {/* Trending Section */}
        <section data-id="element-69">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="flex justify-between items-end mb-4" data-id="element-70">
            <div data-id="element-71">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2" data-id="element-72">
                On Trending Jobs
                <Zap className="w-5 h-5 text-[#00D084] fill-current" data-id="element-73" />
              </h3>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-74">
                Explore jobs that match your skills!
              </p>
            </div>
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="text-xs font-medium text-blue-600 dark:text-blue-400 hover:underline" data-id="element-75">
              Show All
              <span className="block text-[10px] text-blue-400 dark:text-blue-500" data-id="element-76">
                +15 more
              </span>
            </motion.button>
          </motion.div>

          <div className="flex gap-4 overflow-x-auto pb-4 -mx-6 px-6 scrollbar-hide" data-id="element-77">
            {TRENDING_JOBS.map((job, index) => <JobCard key={job.id} job={job} variant="horizontal" index={index} data-id="element-78" />)}
          </div>
        </section>

        {/* Recommendations Section */}
        <section data-id="element-79">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.4
        }} className="bg-[#00D084] dark:bg-gray-800 rounded-2xl p-4 mb-6 text-white shadow-lg relative overflow-hidden" data-id="element-80">
            <motion.div animate={{
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.5, 0.3]
          }} transition={{
            duration: 4,
            repeat: Infinity
          }} className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-10 -mt-10 blur-2xl" data-id="element-81" />
            <div className="flex justify-between items-center relative z-10" data-id="element-82">
              <div data-id="element-83">
                <h3 className="font-bold text-lg flex items-center gap-2" data-id="element-84">
                  Recommendation
                  <Zap className="w-4 h-4 text-yellow-300 fill-current" data-id="element-85" />
                </h3>
                <p className="text-xs text-white/90 dark:text-gray-300 mt-1" data-id="element-86">
                  We've selected these jobs based on your profile.
                </p>
              </div>
              <div className="text-right" data-id="element-87">
                <span className="text-xs font-medium" data-id="element-88">Show All</span>
                <span className="block text-[10px] opacity-80" data-id="element-89">+8 more</span>
              </div>
            </div>
          </motion.div>

          <div className="space-y-4" data-id="element-90">
            {RECOMMENDED_JOBS.map((job, index) => <JobCard key={job.id} job={job} variant="vertical" index={index} data-id="element-91" />)}
          </div>
        </section>
      </div>
    </motion.div>;
}